import type { ApiClient, ConfigsT } from '@prismo-io/schemas';

export const fetchDomains = async (client: ApiClient, term: string | null) => {
  const {
    data: { session },
  } = await client.auth.getSession();

  if (!session) {
    const baseQuery = client
      .from('ref_industries')
      .select('code, referential_id, name')
      .limit(50);

    if (!term) {
      const { data } = await baseQuery;

      return data || [];
    }

    const { data } = await baseQuery.ilike('name', `%${term}%`).limit(50);

    return data || [];
  }

  const baseQuery = client
    .from('users')
    .select(`
      id,
      config(
        industries(
          code,
          referential_id,
          name
        )
      )
    `)
    .eq('id', session.user.id)
    .limit(50, { foreignTable: 'config.industries' })
    .order('name', { foreignTable: 'config.industries' });

  if (!term) {
    const { data } = await baseQuery.maybeSingle();

    if (!data) {
      return [];
    }

    return (data.config as unknown as ConfigsT).industries || [];
  }

  const { data } = await baseQuery
    .ilike('config.industries.name', `%${term}%`)
    .maybeSingle();

  if (!data) {
    return [];
  }

  return (data.config as unknown as ConfigsT).industries || [];
};
